import { cx } from '../internal/tone';

export interface BadgeProps {
  count: number;
  /** Palavra do que é contado, para o leitor de tela: '3 por ler'. */
  label?: string;
  className?: string;
}

/**
 * Contador. Acima de 99 mostra '99+' para não quebrar o alvo de toque ao lado.
 * Zero não desenha nada: um '0' vermelho só assusta.
 */
export function Badge({ count, label = 'por ver', className }: BadgeProps) {
  if (!Number.isFinite(count) || count <= 0) return null;
  const shown = count > 99 ? '99+' : String(count);

  return (
    <span className={cx('flos-badge', className)}>
      <span aria-hidden="true">{shown}</span>
      <span className="flos-sr-only">{`${count} ${label}`}</span>
    </span>
  );
}
